
import React from "react";
import * as Hooks from "../../../../../hooks";
import { i18nManager } from "../../../../../i18n";
import { Schemes, Utils } from "../../../../../utils";
import { Elements } from "../../../../shared/Elements";
import MediaInput from "../../../../shared/MediaInput";
import * as ReactRouterDom from "react-router-dom";
import { ConfirmDialog } from "../../../../shared/ConfirmDialog";
import LoadingGif from "../../../assets/images/loading_circle.gif";
import { Button, ButtonManageRef, Checkbox, ColorHelper, ColorPicker, ColorPickerManageRef, ComponentRenderType, DateInput, Dropdown, Form, FormControl, InputManageRef, NoseurObject, NumberInput, Scheme, Subscriber, TextAreaInput, TextInput, useScreenDimension, useSubscription } from "@rivtn/noseur";
import { ApiResponseData, BaseService, CountryService, ICountry, IMember, IProgram, IHost, ProgramService, SanitizedResponse, HostRole, HostService, TeamTypesValue, ConsusService, IUploadedFile } from "../../../../../services";
import { CreateTournamentSectionProps, CreateTournamentSection } from "../CreateTournament";

function ProgramAndParticipant(props: CreateTournamentSectionProps) {

    const { width } = useScreenDimension();
    const [themeMode, _] = Hooks.useThemeMode();
    const { active, tournamentEditionState } = props;
    const consusService = ConsusService.getInstance();
    const programService = ProgramService.getInstance();
    const [tournament, setTournament] = tournamentEditionState;
    const [programs, setPrograms] = React.useState<IProgram[]>();
    const dialogColorInputRef = React.useRef<InputManageRef>(null);
    const colorPickerManageRef = React.useRef<ColorPickerManageRef>(null);
    const labels = i18nManager.Labels.host.create_tournament.program_and_participant;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    React.useEffect(fetchInformations, []);

    // popover fixture Template send the manage ref
    return (<div className="create-tournament-f flow details" ref={props.ref}>
        {!active && (<div className="overlay" onClick={() => props.setActiveSection(CreateTournamentSection.PROGRAM_AND_PARTICIPANT, undefined, true)} />)}
        <span className="title">{labels.title}</span>
        <Form className="content" scheme={Schemes.OMNEHOST}>
            <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.search_and_select_program, }}
                selectedOptionIndex={programs?.findIndex((p) => p.external_id === tournament.program?.external_id)}  // popoverProps={{ dismissOnClick: true }} - after imple exclusions like for inputs
                options={programs} popoverHeaderTemplate={() => (<div style={{ margin: 10, display: "flex", flexDirection: "column", paddingBottom: 15, borderBottom: "1px solid #E3E3E3" }}>
                    <FormControl isFieldset fill label={labels.search}>
                        <TextInput fill onInput={({ }: any) => {

                        }} />
                    </FormControl>
                    <span className="link" style={{ marginTop: 10, marginLeft: 5 }} onClick={createProgram}>{labels.create_new_program}</span>
                    <span className="link" style={{ marginTop: 10, marginLeft: 5 }} onClick={requestProgram}>{labels.request_program}</span>
                </div>)} optionTemplate={(option: IProgram) => (<div style={{ display: "flex", flexDirection: "row" }}>
                    <img alt={option.name} src={option.logo_urls?.[0]} style={{ width: 40, height: 40, marginRight: 10, borderRadius: "100%" }} />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 500, marginBottom: 2 }}>{option.name} {!option.approved && (<span style={{ fontSize: 12, color: "#FF7171" }}>{labels.pending_approval}</span>)}</span>
                        <span style={{ fontSize: 14 }}>{labels.copyright} {option.copyright}</span>
                    </div>
                </div>)} optionMap={{ label: "name", icon: "{logo_urls[0]}" }} onSelectOption={(program: IProgram) => {
                    setTournament({ ...tournament, program, program_id: program.external_id });
                }} />
            <Dropdown fill formControlProps={{ className: "plan-dd", isFieldset: true, label: labels.participant_per_reg, }}
                selectedOptionIndex={i18nManager.Labels.tournaments.team_types.findIndex((t) => TeamTypesValue[t.value] === tournament.participant_members_count)}
                options={i18nManager.Labels.tournaments.team_types} popoverFooterTemplate={() => (<div style={{ margin: 15 }}>
                    <FormControl isFieldset fill label={labels.custom_no_of_players}>
                        <NumberInput fill defaultValue={tournament.participant_members_count} onInputComplete={(v) => {
                            setTournament({ ...tournament, participant_members_count: parseInt(v) });
                        }} />
                    </FormControl>
                </div>)} onSelectOption={(v) => {
                    setTournament({ ...tournament, participant_members_count: TeamTypesValue[v.value] });
                }} />
            <FormControl isFieldset fill label={labels.allow_extra_team_member}>
                <NumberInput fill defaultValue={tournament.participants_settings?.allowed_extra_team_members} onInputComplete={(v) => {
                    setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, allowed_extra_team_members: parseInt(v) } });
                }} />
            </FormControl>
            <Checkbox label={labels.allow_team_with_incomplete_member} defaultChecked={tournament.participants_settings?.allow_incomplete_team} onChecked={(allow_incomplete_team) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, allow_incomplete_team } });
            }} />
            <FormControl isFieldset fill label={labels.platforms}>
                <TextAreaInput fill style={{ height: 200 }} defaultValue={tournament.participants_settings?.platforms?.join(", ")} onInputComplete={(v) => {
                    setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, platforms: v.split(",").map((v) => v.trim()) } });
                }} />
            </FormControl>
            <FormControl isFieldset fill label={labels.top_x_rank_in_program}>
                <NumberInput fill defaultValue={tournament.participants_settings?.top_xin_program} onInputComplete={(v) => {
                    setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, top_xin_program: parseInt(v) } });
                }} />
            </FormControl>
            <Checkbox label={labels.only_premium_users} defaultChecked={tournament.participants_settings?.premium_members_only} onChecked={(premium_members_only) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, premium_members_only } });
            }} />
            <Checkbox label={labels.non_professional} defaultChecked={tournament.participants_settings?.non_professional} onChecked={(non_professional) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, non_professional } });
            }} />
            <Checkbox label={labels.professional_only} defaultChecked={tournament.participants_settings?.professional} onChecked={(professional) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, professional } });
            }} />
            <Checkbox label={labels.previous_tournament_participants} defaultChecked={tournament.participants_settings?.previous_tournament_participant} onChecked={(previous_tournament_participant) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, previous_tournament_participant } });
            }} />
            <Checkbox label={labels.participants_in_other_tours_from_same_host} defaultChecked={tournament.participants_settings?.previous_participant_in_tournaments_from_same_host} onChecked={(v) => {
                setTournament({ ...tournament, participants_settings: { ...tournament.participants_settings as any, previous_participant_in_tournaments_from_same_host: v } });
            }} />
        </Form>
        <div className="controls">
            <Button textOnly scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.prev} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.DETAILS, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
            <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.next} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                props.setActiveSection(CreateTournamentSection.MEDIA, () => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
        </div>

        <ColorPicker type={ComponentRenderType.POPOVER} manageRef={colorPickerManageRef} onSelectColor={(e) => {
            dialogColorInputRef.current?.setValue(e.color.hex);
        }} />
    </div>);

    function fetchInformations() {
        queryPrograms("");
    }

    function queryPrograms(name: string) {
        programService.queryPrograms({ name }).then(({ content }: SanitizedResponse<IProgram>) => {
            setPrograms(content);
        }).catch(BaseService.reportError);
    }

    function createProgram() {
        const selectedFiles: NoseurObject<File> = {};
        const dialogErrorRef = { current: null } as any;
        const dialogColorRef = { current: null } as any;
        const dialogLabels = labels.dialog.create_program;
        const program: Partial<IProgram> = { extra_data: { color_hex: "#FF0000" } };

        const dialog = ConfirmDialog({
            closable: true,
            title: dialogLabels.title,
            style: { minWidth: "70%" },
            confirmLabel: dialogLabels.create,
            content: (<Form scheme={Schemes.OMNEHOST} style={{ width: "100%", marginTop: 10 }}>
                <FormControl isFieldset fill label={dialogLabels.name} style={{ marginTop: 10 }}>
                    <TextInput fill onInputComplete={(v) => {
                        program.name = v;
                    }} />
                </FormControl>
                <FormControl isFieldset fill label={dialogLabels.short_name} style={{ marginTop: 10 }}>
                    <TextInput fill onInputComplete={(v) => {
                        program.short_name = v;
                    }} />
                </FormControl>
                <FormControl isFieldset fill label={dialogLabels.full_name} style={{ marginTop: 10 }}>
                    <TextInput fill onInputComplete={(v) => {
                        program.full_name = v;
                    }} />
                </FormControl>
                <FormControl isFieldset fill label={dialogLabels.copyright} style={{ marginTop: 10 }}>
                    <TextInput fill onInputComplete={(v) => {
                        program.copyright = v;
                    }} />
                </FormControl>
                <FormControl isFieldset fill label={labels.platforms} style={{ marginTop: 10 }}>
                    <TextAreaInput fill style={{ height: 200 }} onInputComplete={(v) => {
                        program.platforms = v.split(",").map((a) => a.trim());
                    }} />
                </FormControl>
                <FormControl isFieldset fill label={labels.theme_color} style={{ marginTop: 10 }}
                    leftContent={<div ref={dialogColorRef} style={{ width: 20, height: 20, borderRadius: "100%", background: (program?.extra_data?.color_hex) }} />} onClick={(e: any) => {
                        colorPickerManageRef.current?.toggle(e, undefined, [ColorHelper.hexToColor(program?.extra_data?.color_hex!)!]);
                    }}>
                    <TextInput fill readOnly manageRef={dialogColorInputRef} defaultValue={program?.extra_data?.color_hex} onInputComplete={(v) => {
                        program.extra_data = { ...(program.extra_data ?? {}), color_hex: v };
                        dialogColorRef.current.style.background = v;
                    }} />
                </FormControl>
                <Checkbox label={dialogLabels.physical_location} style={{ marginTop: 20 }} onChecked={(c) => {
                    program.extra_data = { ...(program.extra_data ?? {}), physical_location: c };
                }} />
                {dialogLabels.supports_x_accounts.map((acc) => (<Checkbox key={acc} label={`${dialogLabels.supports} ${acc} ${dialogLabels.account}`} style={{ marginTop: 10 }} onChecked={(c) => {
                    program.extra_data = { ...(program.extra_data ?? {}), [`allow_${acc}`]: c };
                }} />))}
                <div ref={dialogErrorRef} className="error"> </div>
            </Form>),
            rightContent: (<div style={{ borderLeft: (width > 800 ? "1px solid #E3E3E3" : undefined), height: "100%", paddingLeft: 15 }}>
                <div style={{ display: "flex" }}>
                    <MediaInput style={{ alignSelf: "center" }} width={180} height={180}
                        instruction={`${dialogLabels.logo} ${i18nManager.Labels.numbers.one}`} onSelectFiles={(files) => {
                            dialogErrorRef.current!.innerText = " ";
                            selectedFiles["logo1"] = files[0];
                        }} onRemove={async () => {
                            delete selectedFiles["logo1"];
                        }} />
                    <MediaInput style={{ alignSelf: "center", marginLeft: 20 }} width={180} height={180}
                        instruction={`${dialogLabels.logo} ${i18nManager.Labels.numbers.two}`} onSelectFiles={(files) => {
                            dialogErrorRef.current!.innerText = " ";
                            selectedFiles["logo2"] = files[0];
                        }} onRemove={async () => {
                            delete selectedFiles["logo2"];
                        }} />
                    <MediaInput style={{ alignSelf: "center", marginLeft: 20 }} width={180} height={180}
                        instruction={`${dialogLabels.logo} ${i18nManager.Labels.numbers.three}`} onSelectFiles={(files) => {
                            dialogErrorRef.current!.innerText = " ";
                            selectedFiles["logo3"] = files[0];
                        }} onRemove={async () => {
                            delete selectedFiles["logo3"];
                        }} />
                </div>
                <MediaInput width={"100%"} height={180}
                    instruction={`${dialogLabels.banner} ${i18nManager.Labels.numbers.one}`} onSelectFiles={(files) => {
                        dialogErrorRef.current!.innerText = " ";
                        selectedFiles["banner1"] = files[0];
                    }} onRemove={async () => {
                        delete selectedFiles["banner1"];
                    }} />
                <MediaInput width={"100%"} height={180}
                    instruction={`${dialogLabels.banner} ${i18nManager.Labels.numbers.two}`} onSelectFiles={(files) => {
                        dialogErrorRef.current!.innerText = " ";
                        selectedFiles["banner2"] = files[0];
                    }} onRemove={async () => {
                        delete selectedFiles["banner2"];
                    }} />
                <MediaInput width={"100%"} height={180}
                    instruction={`${dialogLabels.banner} ${i18nManager.Labels.numbers.three}`} onSelectFiles={(files) => {
                        dialogErrorRef.current!.innerText = " ";
                        selectedFiles["banner3"] = files[0];
                    }} onRemove={async () => {
                        delete selectedFiles["banner3"];
                    }} />
            </div>),
            onConfirm: async (button?: ButtonManageRef) => {
                button?.setLoadingState(true);
                programService.createProgram(program).then(async ({ sanitized: newProgram }: SanitizedResponse<IProgram>) => {
                    for (const key of Object.keys(selectedFiles)) {
                        try {
                            const { sanitized } = await consusService.uploadFile("/omnehost/program/", `${program.short_name?.replaceAll("\s+", "_").toLocaleLowerCase()}_${key}`, selectedFiles[key]);
                            if (key.includes("logo")) {
                                if (!newProgram.logo_urls) newProgram.logo_urls = [];
                                newProgram.logo_urls.push(sanitized.consus_download_url);
                            } else {
                                if (!newProgram.banner_urls) newProgram.banner_urls = [];
                                newProgram.banner_urls.push(sanitized.consus_download_url);
                            }
                        } catch (err: any) {
                            BaseService.reportError(err);
                        }
                    }
                    programService.updateProgram(newProgram).catch(BaseService.reportError);
                    dialog.hide(fetchInformations);
                }).catch(((err) => {
                    dialogErrorRef.current!.innerText = err.errorMessage ?? `${err}`;
                    BaseService.reportError(err);
                })).finally(() => {
                    button?.setLoadingState(false);
                });
                return false;
            }
        });
        dialog.show();
    }

    function requestProgram() {
        const dialogErrorRef = { current: null } as any;
        const dialogLabels = labels.dialog.request_program;

        const dialog = ConfirmDialog({
            closable: true,
            desc: dialogLabels.desc,
            title: dialogLabels.title,
            confirmLabel: dialogLabels.send_request,
            content: (<Form scheme={Schemes.OMNEHOST} style={{ width: "100%", marginTop: 10 }}>
                <FormControl isFieldset fill label={dialogLabels.name} style={{ marginTop: 10 }}>
                    <TextInput fill onInput={({ }: any) => {

                    }} />
                </FormControl>
                <FormControl isFieldset fill label={dialogLabels.company} style={{ marginTop: 10 }}>
                    <TextInput fill onInput={({ }: any) => {

                    }} />
                </FormControl>
                <FormControl isFieldset fill label={dialogLabels.program_info_page} style={{ marginTop: 10 }}>
                    <TextInput fill onInput={({ }: any) => {

                    }} />
                </FormControl>
                <div ref={dialogErrorRef} className="error"> </div>
            </Form>),
            onConfirm: async (button?: ButtonManageRef) => {
                button?.setLoadingState(true);
                return false;
            }
        });
        dialog.show();
    }

}

export default ProgramAndParticipant;
